mutation updateBookingAccessibilityInfo(
  $id: IdInputField!
  $accessibilityInfo: String
) {
  updateBookingAccessibilityInfo(
    bookingId: $id
    accessibilityInfo: $accessibilityInfo
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
